<template>
  <b-col cols="12" md="6" lg="6" xl="6">
    <label for="timepicker">{{ title }}</label>
    <b-form-timepicker
      :id="uniqueId"
      v-bind="labels['hu'] || {}"
      locale="hu"
      menu-class="w-100 timepicker"
      close-button-variant="close"
      label-close-button=""
      v-model="timeValue"
      :hour12="false"
      @shown="shown()"
      @hidden="hidden()"
    ></b-form-timepicker>
    <div v-if="error" class="date-error-message">
      Válasszon időpontot.
    </div>
  </b-col>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    uniqueId: { type: String, required: true },
    error: { type: Boolean },
    alreadySelected: { type: String }
  },
  data() {
    return {
      timeValue: '',
      context: null,
      labels: {
        hu: {
          labelHours: 'Óra',
          labelMinutes: 'Perc',
          labelSeconds: 'Másodperc',
          labelIncrement: 'Növekedés',
          labelDecrement: 'Csökkenés',
          labelSelected: 'Kiválasztott idő',
          labelNoTimeSelected: 'Nincs kiválasztva idő',
          labelCloseButton: 'Bezárás'
        }
      }
    }
  },
  methods: {
    onContext(ctx) {
      this.context = ctx
    },
    shown() {
      this.$emit('which-component-is-open', this.uniqueId)
      this.$emit('shown', true)
    },
    hidden() {
      this.$emit('which-component-is-open', '')
      this.$emit('hidden', false)
    }
  },
  watch: {
    timeValue() {
      this.$emit('time-value', this.timeValue)
    }
  },
  mounted() {
    if (this.alreadySelected !== '') {
      this.timeValue = this.alreadySelected
    }
  }
}
</script>

<style>
#timepicker-1__outer_ {
  border: 2px solid #b2bec3 !important;
}

#timepicker-2__outer_ {
  border: 2px solid #b2bec3 !important;
}

#timepicker-3__outer_ {
  border: 2px solid #b2bec3 !important;
}

#timepicker-4__outer_ {
  border: 2px solid #b2bec3 !important;
}

.time-error-border {
  border: 2px solid #ba3b46 !important;
}

.time-error-message {
  color: #ba3b46;
  text-align: right;
  font-size: 14px;
}

.timepicker {
  text-align: center;
}

.close {
  display: none !important;
}
</style>
